const { useAxios } = require("./useAxios");

export const useFile = () => {
  const { axiosProtected } = useAxios();

  async function urlToFile(url, filename, mimeType) {
    const response = await axiosProtected.get(url, {
      responseType: "blob",
      headers: {
        Accept: "*/*", // Allow any content type for blob requests
      },
    });
    const blob = response.data;

    return new File([blob], filename, {
      type: mimeType || blob.type,
      lastModified: Date.now(),
    });
  }

  const handleUrlToFile = async (cb, ...args) => {
    try {
      const urls = args[0];
      if (Array.isArray(urls)) {
        const files = await Promise.all(
          urls.map((url) => urlToFile(url, "time"))
        );
        cb(files);
      } else {
        const file = await urlToFile(urls, "time");
        cb([file]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { handleUrlToFile };
};
